export default __webpack_public_path__ + "static/media/reddit.7cf4310b.png";